import {setLocationHref, setURLParams} from 'BenchlingUtil';

export function redirectToModelHubSignup(nextURL?: string): void {
  const params: Record<string, string> = {};
  if (nextURL != null && nextURL !== '') {
    params.next = nextURL;
  }
  setLocationHref(setURLParams('/signup', params));
}
